import { lazy } from 'react';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';

const ModuleLoaderLazy = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "damz_global_shared", webpackPrefetch: true */
        './ModuleLoader'
      )
  )
);

export default ModuleLoaderLazy;
